module.exports = __webpack_public_path__ + "img/7_156.4da85bcf.png";